import React, { useEffect } from "react";
import route from "../assets/routes.svg";
import curveLine from "../assets/curveLine.png";
import eclipse from "../assets/Elipse.png";
import account from "../assets/account.svg";
import guardian from "../assets/guardian.svg";
import Halal from "../assets/Halal.svg";
import guardianID from "../assets/guardianID.svg";
import card_bg from "../assets/card_bg.png";
import { LuDot } from "react-icons/lu";
import AOS from "aos";
import "aos/dist/aos.css";

const HowItWorks = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);

  return (
    <div className="py-16">
      <h2 className="flex flex-col items-center gap-5 text-center text-4xl sm:text-5xl  text-themeColor mb-8 font-yeseva pb-5">
        How it works
        <div className="font-sans px-5 text-black text-lg md:w-[60%] mx-auto">
          Getting started with My Wali is simple and straightforward. Whether
          you’re a seeker or a guardian, you can quickly register and create a
          joint seeker account.
        </div>
        <div>
          <img src={curveLine} alt="" />
        </div>
      </h2>
      <div className="w-full relative">
        <div
          className="w-[80%] m-auto flex flex-wrap gap-8 justify-center"
        >
          {steps.map((step, index) => (
            <div
          data-aos="fade-up"
              key={index}
              // style={{
              //   backgroundImage: `url(${card_bg})`,
              //   backgroundSize: "cover",
              //   backgroundPosition: "center",
              //   backgroundRepeat: "no-repeat",
              // }}
              className="w-[300px] rounded-2xl  text-start relative pb-5 border-[1.5px]"
            >
              <div className="absolute bg-themeColor font-yeseva text-white w-12 py-[2px] rounded-r-full text-lg mt-5 text-center">
                {step.number}
              </div>
              <div className="h-28 mt-8 mb-2">
                <img
                  src={step.image}
                  alt={step.title}
                  className="w-32 mx-auto"
                />
              </div>
              <h3 className="text-[20px] text-themeColor font-sans font-semibold my-3 px-6 leading-5 text-center pt-2">
                {step.title}
              </h3>
              {step?.description.map((items, i) => (
                <p key={i} className="text-black font-poppins text-[12px] px-5 flex gap-1 items-start pt-1.5">
                  <div className="w-4">
                    <LuDot className="text-xl" />
                  </div>
                  {items}
                </p>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const steps = [
  {
    number: "01",
    title: "Create Seeker Account",
    description: ["Begin by signing up and creating your seeker account."],
    image: account,
  },
  {
    number: "02",
    title: "Register Your Guardian",
    description: [
      "Your guardian will receive an invitation via email or SMS to confirm their role and involvement in your journey.",
      "They can then download the app and take a proactive step towards your match-making process.",
    ],
    image: guardian,
  },
  {
    number: "03",
    title: "Guardian ID Verification",
    description: [
      "Your guardian will need to upload a government-issued ID for verification.",
      "Our team will review the submitted documents and verify your guardian’s identity within 24-48 hours.",
    ],
    image: guardianID,
  },
  {
    number: "04",
    title: "Create Your Seeker Profile",
    description: [
      "After verification, complete your profile and set your preferences.",
    ],
    image: account,
  },
  {
    number: "05",
    title: "Start Your Halal Journey",
    description: [
      "Your profile is now active -you can now start ",
      "You can now start browsing potential matches, with your guardian actively involved every step of the way.",
    ],
    image: Halal,
  },
];

export default HowItWorks;
